// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6d012782","453":"e3f10b49","455":"f54218c9","977":"706caf2e"}[chunkId] + ".chunk.js";
};